module.exports = __webpack_public_path__ + "static/media/outreach-2.0e6e16eb.png";